export default __webpack_public_path__ + "static/media/logo-exeltis-white.ff234a79.svg";